export const GENERIC_ERROR_MESSAGE = 'An unknown error occurred';
export const API_STATUS_ERROR_MESSAGE = {
  401: 'Your are not authorised to perform this action',
  500: GENERIC_ERROR_MESSAGE
};